import {apiConstants} from "./constants";
import * as api from "../../utils/api"

export function getCompanies(email, password) {
  return {payload: api.getCompanies(), type: apiConstants.companies.base};
}



// WEBPACK FOOTER //
// ./src/redux/actions/companies.js